module.exports = __webpack_public_path__ + "static/media/icons_remove_map.b00ee547.svg";